<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ 'Projekt ' | mrTranslate }}{{ sBez }}</span>
    </div>
    <div class="header-actions">
      <a href="javascript://" class="nav-link nav-icon">
        <cds-icon shape="floppy" (click)="saveNewProject()"></cds-icon>
      </a>
      <a href="javascript://" class="nav-link nav-icon">
        <cds-icon shape="window-close" (click)="close()"></cds-icon>
      </a>
    </div>
  </header>

  <div class="clr-col-9">
    <clr-tabs>
      <clr-tab>
        <button clrTabLink>{{ 'Projektdaten' | mrTranslate }}</button>
        <ng-template [(clrIfActive)]="prjActive"></ng-template>
      </clr-tab>
      <clr-tab>
        <button clrTabLink>{{ 'Anlagenobjekte' | mrTranslate }}</button>
        <ng-template [(clrIfActive)]="anlActive"></ng-template>
      </clr-tab>
      <clr-tab>
        <button clrTabLink>{{ 'Historie' | mrTranslate }}</button>
        <ng-template [(clrIfActive)]="histActive"></ng-template>
      </clr-tab>
    </clr-tabs>
  </div>
  <form clrForm ngForm [formGroup]="neuProjektFormGroup" clrLayout="horizontal" clrLabelSize="8">
    @if (prjActive) {
      <clr-input-container>
        <label class="clr-col-md-2">{{ 'Titel' | mrTranslate }}</label>
        <input clrInput type="text" class="textLine" name="titel" formControlName="titel" />
        <clr-control-error *clrIfError="'required'">
          {{ "Feld 'Titel' muss ausgefüllt werden!" | mrTranslate }}
        </clr-control-error>
      </clr-input-container>

      <clr-datalist-container>
        <label class="clr-col-md-2">{{ 'Verantwortlich' | mrTranslate }}</label>
        <input
          style="width: 400px"
          clrDatalistInput
          type="search"
          name="verantwortlich"
          formControlName="verantwortlich" />
        <datalist>
          @for (wert of verantwortliche; track wert) {
            <option [value]="wert"></option>
          }
        </datalist>
        <clr-control-error *clrIfError="'required'">
          {{ "Feld 'Verantwortlich' muss ausgefüllt werden!" | mrTranslate }}
        </clr-control-error>
      </clr-datalist-container>

      <clr-select-container>
        <label class="clr-col-md-2" style="display: block">{{ 'Projektstatus' | titlecase | mrTranslate }}</label>
        <select
          style="width: 400px"
          clrSelect
          formControlName="projektstatus"
          name="projektstatus"
          (change)="selectedStatusChanged()">
          @for (obj of projektStatusLst; track obj) {
            <option [ngValue]="+obj.ID">
              {{ obj.Bezeichnung }}
            </option>
          }
        </select>
        <clr-control-error *clrIfError="'required'">
          {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
        </clr-control-error>
      </clr-select-container>

      <clr-date-container>
        <label class="clr-col-md-2">{{ 'Beginn' | mrTranslate }}</label>
        <input
          clrDate
          name="Datum"
          class="textLine"
          autocomplete="off"
          type="date"
          [ngModel]="neuProjektFormGroup.controls['projektbeginn'].value | localeDate"
          (ngModelChange)="neuProjektFormGroup.controls['projektbeginn'].setValue(localeDate.tosql($event))"
          [ngModelOptions]="{ updateOn: 'blur', standalone: true }" />
        @if (limitVon != 10000) {
          <clr-control-helper>{{ '>=' }} {{ limitVon | localeDate }}</clr-control-helper>
        }
      </clr-date-container>
      <clr-date-container>
        <label class="clr-col-md-2">{{ 'Ende' | mrTranslate }}</label>
        <input
          clrDate
          name="Datum"
          class="textLine"
          autocomplete="off"
          type="date"
          [ngModel]="neuProjektFormGroup.controls['projektende'].value | localeDate"
          (ngModelChange)="neuProjektFormGroup.controls['projektende'].setValue(localeDate.tosql($event))"
          [ngModelOptions]="{ updateOn: 'blur', standalone: true }" />
        @if (limitVon != 10000) {
          <clr-control-helper>{{ '<=' }} {{ limitBis | localeDate }}</clr-control-helper>
        }
      </clr-date-container>

      <clr-number-input-container>
        <label class="clr-col-md-2">{{ 'Projektsumme' | mrTranslate }}</label>
        <input clrNumberInput type="number" class="textLine" name="intervall" formControlName="projektsumme" />
        <clr-control-error *clrIfError="'required'">
          {{ "Feld 'Projektsumme' muss ausgefüllt werden!" | mrTranslate }}
        </clr-control-error>
      </clr-number-input-container>

      <clr-datalist-container>
        <label class="clr-col-md-2">{{ 'Kostenstelle' | mrTranslate }}</label>
        <input
          style="width: 400px"
          class="clr-col-md-10"
          clrDatalistInput
          type="search"
          name="kostenstelle"
          formControlName="kostenstelle" />
        <datalist>
          @for (wert of kostenstellen; track wert) {
            <option [value]="wert"></option>
          }
        </datalist>
      </clr-datalist-container>

      <clr-input-container>
        <label class="clr-col-md-2">{{ 'Kurztext' | mrTranslate }}</label>
        <input clrInput type="text" class="textLine" name="kurztext" formControlName="kurztext" />
        <clr-control-error *clrIfError="'required'">
          {{ "Feld 'Kurztext' muss ausgefüllt werden!" | mrTranslate }}
        </clr-control-error>
      </clr-input-container>

      <clr-textarea-container>
        <label class="clr-col-md-2">{{ 'Langtext' | mrTranslate }}</label>
        <textarea
          id="aa"
          class="clr-col-md-10"
          clrTextarea
          formControlName="langtext"
          style="width: 100%; height: 150px"></textarea>
      </clr-textarea-container>

      <clr-textarea-container>
        <label class="clr-col-md-2">{{ 'Bemerkung' | mrTranslate }}</label>
        <textarea
          id="aa"
          class="clr-col-md-10"
          clrTextarea
          formControlName="bemerkung"
          style="width: 100%; height: 150px"></textarea>
      </clr-textarea-container>

      <clr-input-container>
        <label class="clr-col-md-2">{{ 'Farbe' | mrTranslate }}</label>
        <input type="color" formControlName="diagrammfarbe" #colorBase />
      </clr-input-container>
      <cds-icon
        shape="circle"
        style="left: 16vw; position: relative; margin-top: -60px; width: 30px; height: 30px"
        solid="true"
        class="cursor-pointer"
        (click)="colorFocusInput(colorBase)"
        [ngStyle]="{ color: neuProjektFormGroup.value.diagrammfarbe }" />

      @if (mode() == 'open') {
        <clr-checkbox-container class="margin-0-t">
          <clr-checkbox-wrapper>
            <label style="min-width: 300px">{{ 'Erledigt' | mrTranslate }}</label>
            <input type="checkbox" clrCheckbox formControlName="erledigt" />
          </clr-checkbox-wrapper>
        </clr-checkbox-container>

        <clr-date-container>
          <label class="clr-col-md-2">{{ 'Datum' | mrTranslate }}</label>
          <input
            clrDate
            name="Datum"
            class="textLine"
            autocomplete="off"
            type="date"
            [ngModel]="neuProjektFormGroup.controls['datum'].value | localeDate"
            [ngModelOptions]="{ updateOn: 'blur', standalone: true }" />
        </clr-date-container>

        <clr-input-container>
          <label class="clr-col-md-2">{{ 'Lieferant' | mrTranslate }}</label>
          <input clrInput type="text" class="textLine" name="lieferant" formControlName="lieferant" />
        </clr-input-container>

        <clr-number-input-container>
          <label class="clr-col-md-2">{{ 'Kosten' | mrTranslate }}</label>
          <input clrNumberInput type="number" class="textLine" name="kosten" formControlName="kosten" />
        </clr-number-input-container>
      }
    }
  </form>
  @if (anlActive) {
    <div class="clr-row">
      <clr-button-group class="btn-sm btn-outline" style="margin-top: 0.5em">
        <clr-button (click)="openAnlagen()">
          <cds-icon [title]="'Anlagenliste öffnen' | mrTranslate" size="20" shape="file" />
          <span class="clr-icon-title">&nbsp;{{ 'Anlagenliste' | mrTranslate }}</span>
        </clr-button>
        <clr-button (click)="createSpezifikationen()">
          <cds-icon [title]="'Spezifikation bearbeiten' | mrTranslate" size="20" shape="list" />
          <span class="clr-icon-title">&nbsp;{{ 'Spezifikation' | mrTranslate }}</span>
        </clr-button>
        <clr-button (click)="removeAnlagen()" [disabled]="!this.anlSelected">
          <cds-icon [title]="'Anlage entfernen' | mrTranslate" size="20" shape="delete" />
          <span class="clr-icon-title">&nbsp;{{ 'Anlage entfernen' | mrTranslate }}</span>
        </clr-button>
      </clr-button-group>
    </div>

    <clr-datagrid
      #dgStammdaten
      class="datagrid-compact"
      [clrDgSelectionType]="'single'"
      [clrDgSelected]="[anlSelected]"
      (clrDgSelectedChange)="anlSelected = $event[0]; changeAnlRow($event[0])">
      @for (column of stammdaten.columns; track column) {
        <clr-dg-column [clrDgField]="column.id">
          <ng-container
            *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['projectid', 'typ', 'newspez', 'stammid','parentid'] }">
            {{ column.id | mrTranslate | titlecase }}
          </ng-container>
        </clr-dg-column>
      }
      <clr-dg-row *clrDgItems="let row of stammdaten.rows" [clrDgItem]="row">
        @for (cell of stammdaten.columns; track cell) {
          <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
        }
      </clr-dg-row>
      <clr-dg-footer>{{ stammdaten.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
    </clr-datagrid>
  }
  @if (histActive) {
    <clr-datagrid #dgHistorie class="datagrid-compact w-100-p wrapColumn" [clrDgRowSelection]="true">
      @for (column of history.columns; track column) {
        <clr-dg-column [clrDgField]="column.id">
          <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['bildpfad'] }">
            {{ column.id | mrTranslate | titlecase }}
          </ng-container>
        </clr-dg-column>
      }
      <clr-dg-row *clrDgItems="let row of history.rows" [clrDgItem]="row">
        @for (cell of history.columns; track cell) {
          <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
        }
      </clr-dg-row>
      <clr-dg-footer>{{ history.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
    </clr-datagrid>
  }

  <!-- Modalfenster Anlagenauswahl -->
  <clr-modal [(clrModalOpen)]="showAnlSelection" [clrModalSize]="'xl'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Anlagen auswählen' | mrTranslate }}</h3>
    <div class="modal-body">
      @if (anlagen()?.columns.length) {
        <clr-datagrid
          class="datagrid-compact"
          style="height: 50vh"
          [clrDgSelectionType]="'multi'"
          [clrDgSelected]="selected()"
          (clrDgSelectedChange)="selected.set($event)"
          [clrDgRowSelection]="true"
          [clrDgItemsIdentityFn]="row => row?.OSTAMMID">
          @for (column of anlagen().columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id">
              <clr-dg-filter [attr.data-test-id]="'datagrid-sammel-col-filter-' + column.id">
                <app-column-filter
                  [column]="column"
                  [objektTypIconValue]="filterStore.iconMap()"
                  [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                  (changes)="filterStore.onChange($event)" />
              </clr-dg-filter>

              <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                {{
                  column.id == 'KAV' ?
                    anlagen().rows[0]?.KAV?.toString().includes('%') ?
                      'SAX'
                    : 'KAV'
                  : (column.id | titlecase | mrTranslate)
                }}
              </ng-container>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="filteredRows()"
            [clrVirtualRowsTrackBy]="(_, row) => row?.OSTAMMID">
            <clr-dg-row [clrDgItem]="row">
              @for (cell of anlagen().columns; track cell.id) {
                <clr-dg-cell><app-icon-dg-cell [column]="cell" [row]="row" /></clr-dg-cell>
              }
            </clr-dg-row>
          </ng-template>
          <clr-dg-footer>{{ filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="addAnlagen()">{{ 'OK' | mrTranslate }}</button>
      <button type="button" class="btn" (click)="showAnlSelection = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>

  <!-- Modalfenster Mangelauswahl nach Speichern als "erledigt" -->
  <clr-modal [(clrModalOpen)]="showMangSelection" [clrModalSize]="'xl'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Mängel auswählen' | mrTranslate }}</h3>
    <div class="modal-body">
      @if (maengel()?.columns.length) {
        <clr-datagrid
          class="datagrid-compact"
          style="height: 50vh"
          [clrDgSelectionType]="'multi'"
          [clrDgSelected]="maengelselected()"
          (clrDgSelectedChange)="maengelselected.set($event)"
          [clrDgRowSelection]="true"
          [clrDgItemsIdentityFn]="row => row?.OMAZSID">
          @for (column of maengel().columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id">
              <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                {{ column.id | titlecase | mrTranslate }}
              </ng-container>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="maengel().rows"
            [clrVirtualRowsTrackBy]="(_, row) => row?.OMAZSID">
            <clr-dg-row [clrDgItem]="row">
              @for (cell of maengel().columns; track cell.id) {
                <clr-dg-cell><app-icon-dg-cell [column]="cell" [row]="row" /></clr-dg-cell>
              }
            </clr-dg-row>
          </ng-template>
          <clr-dg-footer>{{ maengel().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="saveProject()">{{ 'OK' | mrTranslate }}</button>
      <button type="button" class="btn" (click)="showMangSelection = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>
</div>
